export default __webpack_public_path__ + "static/media/pin-old-hostel.12ae237b.png";